import { render, staticRenderFns } from "./JoinToBHC.vue?vue&type=template&id=dc86150e&scoped=true"
import script from "./JoinToBHC.vue?vue&type=script&lang=js"
export * from "./JoinToBHC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc86150e",
  null
  
)

export default component.exports